import { ns } from '@leverege/i18n';
import { Button, Checkbox, NumericInput, PropertyGrid, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import classnames from 'classnames';
import React, { useState } from 'react';
import S from './IntFormatterEditor.css';
import Model from "./IntFormatterModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.IntFormatterEditor');

/**
 * Editor for number formatter.
 * @param {Object} props.value - Value formatter object.
 * @param {String} props.value.type - Value type, e.g. attr.formatter.number.
 */
export default function IntFormatterEditor(props) {
  // Get parameters
  const {
    value,
    onChange,
    eventData
  } = props;
  const [newKey, setNewKey] = useState();
  const [newValue, setNewValue] = useState();
  const onModelChange = useValueChange(Model, props);

  // Validate parameters
  if (value == null) {
    return null;
  }
  const addMapValue = e => {
    if (typeof newKey !== 'number') {
      return;
    }
    if (value?.lookup?.[e.value] === undefined) {
      const nm = Model.setMapping(value, newKey, newValue);
      if (onChange) {
        onChange({
          data: eventData,
          value: nm,
          oldValue: value
        });
      }
      setNewKey(null);
      setNewValue(null);
    }
  };
  const removeMapValue = e => {
    const nm = Model.removeMapping(value, e.data);
    if (onChange) {
      onChange({
        data: eventData,
        value: nm,
        oldValue: value
      });
    }
  };
  const mappings = Object.entries(Model.getMappings(value));
  mappings.sort((a, b) => {
    return a[0] - b[0];
  });
  // TODO: Render editor
  return /*#__PURE__*/_jsxs(PropertyGrid, {
    style: {
      backgroundColor: 'var(--color-white)',
      border: 0
    },
    children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('unsetValue'),
      children: /*#__PURE__*/_jsx(TextInput, {
        size: 24,
        eventData: "setUnset",
        value: Model.getUnset(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('prefix'),
      children: /*#__PURE__*/_jsx(TextInput, {
        size: 24,
        eventData: "setPrefix",
        value: Model.getPrefix(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('suffix'),
      children: /*#__PURE__*/_jsx(TextInput, {
        size: 24,
        eventData: "setSuffix",
        value: Model.getSuffix(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      stretch: true,
      label: t('mapValues'),
      children: /*#__PURE__*/_jsxs("div", {
        className: classnames(S.fill, S.mappingGrid),
        children: [mappings.map(([k, v]) => {
          return [/*#__PURE__*/_jsx("div", {
            children: k
          }, k), /*#__PURE__*/_jsx(TextInput, {
            value: v
          }, `${k}-v`), /*#__PURE__*/_jsx(Button, {
            eventData: k,
            variant: "link",
            icon: "fa fa-trash fa-fw",
            onClick: removeMapValue
          }, `${k}-r`)];
        }), /*#__PURE__*/_jsx(NumericInput, {
          hint: "Value",
          value: newKey,
          onChange: e => setNewKey(e.value)
        }), /*#__PURE__*/_jsx(TextInput, {
          hint: "Mapping",
          value: newValue,
          onChange: e => setNewValue(e.value)
        }), /*#__PURE__*/_jsx(Button, {
          variant: "link",
          onClick: addMapValue,
          children: t('add')
        })]
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('localize'),
      children: /*#__PURE__*/_jsx(Checkbox, {
        containerClassName: S.fill,
        value: Model.getLocalize(value),
        onChange: onModelChange,
        eventData: "setLocalize"
      })
    })]
  });
}